
import React from 'react';
import StatCard from '@/components/StatCard';
import { Users, RefreshCw, CreditCard } from 'lucide-react';

interface DashboardStatsSectionProps {
  stats: {
    totalUsers: number;
    activeUsers: number;
    totalReferrals: number;
    revenue: number;
  };
}

const DashboardStatsSection: React.FC<DashboardStatsSectionProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <StatCard
        title="Total Users"
        value={stats.totalUsers.toString()}
        icon={<Users className="h-8 w-8 text-primary-blue" />}
        description="Registered users"
      />
      <StatCard
        title="Active Users"
        value={stats.activeUsers.toString()}
        icon={<Users className="h-8 w-8 text-green-500" />}
        description="Users active this month"
      />
      <StatCard
        title="Total Referrals"
        value={stats.totalReferrals.toString()}
        icon={<RefreshCw className="h-8 w-8 text-indigo-500" />}
        description="All-time referrals"
      />
      <StatCard
        title="Revenue"
        value={`$${stats.revenue.toFixed(2)}`}
        icon={<CreditCard className="h-8 w-8 text-emerald-500" />}
        description="This month"
      />
    </div>
  );
};

export default DashboardStatsSection;
